import React from "react";
import { FaCheck } from "react-icons/fa";
import "./checkbox.css";
import ToolTip from "@components/Tooltip";

export const Checkbox = ({
  label,
  name,
  checked,
  onChange,
  disabled,
  className,
  labelClassName,
  icon,
  tooltipContent,
  indeterminate = false,
}) => {
  return (
    <div
      style={{ marginRight: "0px" }}
      className={`checkbox ${className && className !== "" ? className : ""}`}
    >
      <input
        type='checkbox'
        disabled={disabled === undefined ? false : disabled}
        onChange={onChange}
        id={name}
        indeterminate={indeterminate}
        name={name}
        checked={checked}
        className='disabled:cursor-not-allowed'
      />
      <label
        htmlFor={name}
        className={
          labelClassName ? labelClassName : "text-xs text-gray-800 font-medium"
        }
      >
        <span className='box'>
          {icon || <FaCheck className='check-icon' />}
        </span>
        {label || ""}
      </label>
      {tooltipContent && (
        <ToolTip toolTipContent={tooltipContent} className='pl-2' />
      )}
    </div>
  );
};

export default Checkbox;
